<template>
  <dl>
    <dd class="info">
      <span class="label">{{ orgDst.airlineName }} {{
        orgDst.flightNo
      }}</span>
      <span class="txt">{{ orgDst.departureDate }}&nbsp;&nbsp;{{
        orgDst.departureDate | format('dddd')
      }}</span>
    </dd>
    <dd class="detail">
      <div>
        <span class="label">{{ orgDst.departureTime | format('HH:mm') }}</span>
        <span class="txt">{{ orgDst.departureAirPortName }}{{
          orgDst.departureTerminal
        }}</span>
      </div>
      <div v-if="orgDst.stopAirportName">
        <span class="label"></span>
        <span class="txt">经停 {{ orgDst.stopAirportName }}{{
          orgDst.stopTerminal || ''
        }}</span>
      </div>
      <div>
        <span class="label">{{ orgDst.arrivalTime | format('HH:mm') }}<span class="gt-day">{{
          orgDst | gtDay
        }}</span></span>
        <span class="txt">{{ orgDst.arrivalAirPortName }}{{
          orgDst.arrivalTerminal
        }}</span>
      </div>
    </dd>
  </dl>
</template>
<script>
export default {
  props: {
    orgDst: Object
  }
}
</script>
<style lang="less" scoped>

</style>
